import { render, staticRenderFns } from "./OxygenSelectInput.vue?vue&type=template&id=087c8b2a&scoped=true&"
import script from "./OxygenSelectInput.vue?vue&type=script&lang=ts&"
export * from "./OxygenSelectInput.vue?vue&type=script&lang=ts&"
import style0 from "./OxygenSelectInput.vue?vue&type=style&index=0&id=087c8b2a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087c8b2a",
  null
  
)

export default component.exports